export default __webpack_public_path__ + "static/media/oneKG.fea13cd2.png";